// Título de pantalla del topbar cuando el nav no alcanza para nombrarlo.
//
// El `AppShell` lo saca del item activo del menú, que es un rótulo fijo («Mi tienda»). Hay pantallas
// cuyo mock lo nombra con un dato que solo se conoce al leer el silo («Mi tienda · Iztapalapa»);
// esta tienda deja que la pantalla lo pise, y vuelve al rótulo del nav al desmontarse.
import { useEffect } from 'react';
import { create } from 'zustand';

interface ScreenTitleState {
    title: string | null;
    setTitle: (title: string | null) => void;
}

export const useScreenTitleStore = create<ScreenTitleState>((set) => ({
    title: null,
    setTitle: (title) => {
        set({ title });
    },
}));

/** Pisa el título del topbar mientras la pantalla está montada. `null` = deja el del nav. */
export function useScreenTitle(title: string | null): void {
    const setTitle = useScreenTitleStore((s) => s.setTitle);
    useEffect(() => {
        setTitle(title);
        return () => {
            setTitle(null);
        };
    }, [title, setTitle]);
}
